import { i18n } from '@fs/zion-locale'

export default {
  notAvailable: () => i18n.t('dataNotAvailable', 'Not Available'),
}
